import httpService from '@/utils/request'
import { contextPath } from '@/config/'
export const queryCollectDetaileByIdApi = (params) => {
  return httpService({
    url: contextPath + '/subject/content/item/detail',
    method: 'get',
    params
  })
}

export const queryByIdsOrUrlsApi = (params, data) => {
  return httpService({
    url: contextPath + '/subject/content/list/queryByIdsOrUrls',
    method: 'POST',
    params,
    data
  })
}
